import {INITIAL_DASHBOARD_MODAL_FORM_DATA} from '../../helpers/constants';
import {ActionTypes} from './dashboard-actions';

export const getInitialState = () => ({
  id: null,
  defaultImageBase64: '',
  imageUploadOptions: [],
  permissionSettingOptions: [],
  widgetTypes: [],
  modalFormData: {
    ...INITIAL_DASHBOARD_MODAL_FORM_DATA,
  },
  isInEditMode: false,
  dashboards: [],
  feedData: {},
  availableTags: {},
  schedulesFeed: {},
  futureSchedulesFeed: [],
  pastSchedulesFeed: [],
  osPaths: {},
  osMap: {},
  highlightedDashboard: null,
  isFetchingDashboards: false,
  favoriteDashboards: [],
  otherDashboards: [],
  dashboardsForExport: [],
  schedulesError: null,
  isFetchingSchedules: false,
  publishingDashboard: false,
  resourcesLoaded: {
    widgetTypes: false,
    imageOptions: false,
    permissionOptions: false,
  },
  commonResourcesLoaded: {
    imageOptions: false,
    permissionOptions: false,
    widgetTypes: false,
  },
  isExportMode: false,
});

const initialState = getInitialState();
const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'DESTROY': {
      return getInitialState();
    }
    case ActionTypes.DASHBOARD_UPDATE_MODAL_FORM_DATA: {
      if (action.prop) {
        return {
          ...state,
          modalFormData: {
            ...state.modalFormData,
            [action.prop]: action.data,
          },
        };
      }
      return {
        ...state,
        modalFormData: {
          ...state.modalFormData,
          ...action.data,
        },
      };
    }
    case ActionTypes.DASHBOARD_SET_IMAGE_OPTIONS: {
      return {
        ...state,
        imageUploadOptions: action.imageOptions,
        defaultImageBase64: action.defaultImage,
        resourcesLoaded: {
          ...state.resourcesLoaded,
          imageOptions: true,
        },
      };
    }
    case ActionTypes.DASHBOARD_SET_PERMISSION_OPTIONS: {
      return {
        ...state,
        permissionSettingOptions: action.permissionOptions,
        resourcesLoaded: {
          ...state.resourcesLoaded,
          permissionOptions: true,
        },
      };
    }
    case ActionTypes.DASHBOARD_SET_WIDGET_TYPES: {
      return {
        ...state,
        widgetTypes: action.widgetTypes,
        widgetTypesLoaded: true,
        resourcesLoaded: {
          ...state.resourcesLoaded,
          widgetTypes: true,
        },
      };
    }
    case ActionTypes.DASHBOARD_GET_ALL: {
      return {
        ...state,
        dashboards: [],
        favoriteDashboards: [],
        otherDashboards: [],
        resourcesLoaded: {
          ...state.resourcesLoaded,
          dashboards: false,
        },
      };
    }
    case ActionTypes.DASHBOARD_SET_ALL: {
      return {
        ...state,
        dashboards: action.dashboards,
        favoriteDashboards: action.favoriteDashboards,
        otherDashboards: action.otherDashboards,
        isFetchingDashboards: false,
        availableTags: action.availableTags,
        resourcesLoaded: {
          ...state.resourcesLoaded,
          dashboards: true,
          tags: true,
        },
      };
    }
    case ActionTypes.DASHBOARD_RESET_ALL: {
      return {
        ...initialState,
        dashboards: state.dashboards,
        favoriteDashboards: state.favoriteDashboards,
        otherDashboards: state.otherDashboards,
        highlightedDashboard: state.highlightedDashboard,
        defaultImageBase64: state.defaultImageBase64,
        imageUploadOptions: state.imageUploadOptions,
        permissionSettingOptions: state.permissionSettingOptions,
        widgetTypes: state.widgetTypes,
        osPaths: state.osPaths,
        shortcutAndHotkeysOptions: state.shortcutAndHotkeysOptions,
        osMap: state.osMap,
        dashboardRotation: state.dashboardRotation,
        resourcesLoaded: state.resourcesLoaded,
        availableTags: state.availableTags,
      };
    }
    case ActionTypes.DASHBOARD_GET_ALL_DEVICES: {
      return {
        ...state,
        feedData: {},
      };
    }
    case ActionTypes.DASHBOARD_GET_ALL_DEVICES_SUCCESS: {
      return {
        ...state,
        feedData: action.feedData,
      };
    }
    case ActionTypes.DASHBOARD_GET_SCHEDULES_START: {
      return {
        ...state,
        isFetchingSchedules: true,
      };
    }
    case ActionTypes.DASHBOARD_GET_SCHEDULES_SUCCESS: {
      return {
        ...state,
        isFetchingSchedules: false,
        schedulesFeed: action.payload,
        schedulesError: null,
      };
    }
    case ActionTypes.SCHEDULES_ERROR: {
      return {
        ...state,
        isFetchingSchedules: false,
        schedulesError: action.data.errorMsg,
        schedulesFeed: {},
      };
    }
    case ActionTypes.DASHBOARD_GET_FUTURE_SCHEDULES_START: {
      return {
        ...state,
        isFetchingSchedules: true,
      };
    }
    case ActionTypes.DASHBOARD_GET_FUTURE_SCHEDULES_SUCCESS: {
      return {
        ...state,
        isFetchingSchedules: false,
        futureSchedulesFeed: action.payload,
      };
    }
    case ActionTypes.DASHBOARD_GET_PAST_SCHEDULES_START: {
      return {
        ...state,
        isFetchingSchedules: true,
      };
    }
    case ActionTypes.DASHBOARD_GET_PAST_SCHEDULES_SUCCESS: {
      return {
        ...state,
        isFetchingSchedules: false,
        pastSchedulesFeed: action.payload,
      };
    }
    case ActionTypes.DASHBOARD_SET_OS_PATHS: {
      return {
        ...state,
        osPaths: action.paths,
      };
    }
    case ActionTypes.DASHBOARD_SET_OS_MAP: {
      return {
        ...state,
        osMap: action.osMap,
      };
    }
    case ActionTypes.SET_HIGHLIGHTED_DASHBOARD: {
      return {
        ...state,
        highlightedDashboard: action.dashboardName,
      };
    }
    case ActionTypes.CLEAR_HIGHLIGHTED_DASHBOARD: {
      return {
        ...state,
        highlightedDashboard: null,
      };
    }
    case ActionTypes.FETCHING_DASHBOARDS: {
      return {
        ...state,
        isFetchingDashboards: action.fetching !== undefined ? action.fetching : true,
      };
    }
    case ActionTypes.SET_FAVORITE_DASHBOARDS: {
      return {
        ...state,
        favoriteDashboards: action.dashboards,
      };
    }
    case ActionTypes.DASHBOARD_SET_PUBLISHING_STATUS: {
      return {
        ...state,
        publishingDashboard: action.publishingDashboard,
      };
    }
    case ActionTypes.DASHBOARD_SET_EXPORT_MODE: {
      return {
        ...state,
        isExportMode: action.isExportMode,
      };
    }
    case ActionTypes.ADD_DASHBOARD_FOR_EXPORT: {
      return {
        ...state,
        dashboardsForExport: [...state.dashboardsForExport, action.dashboardData],
      };
    }
    case ActionTypes.REMOVE_DASHBOARD_FOR_EXPORT: {
      return {
        ...state,
        dashboardsForExport: state.dashboardsForExport.filter(
          (dashboardForExport) => dashboardForExport.id !== action.dashboardId
        ),
      };
    }
    case ActionTypes.REMOVE_ALL_DASHBOARDS_FOR_EXPORT: {
      return {
        ...state,
        dashboardsForExport: [],
      };
    }
    default:
      return state;
  }
};

export default dashboardReducer;
